import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="terms-of-service-page container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8 text-center">Terms of Service</h1>
      
      <div className="text-base text-white leading-relaxed">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
          <p className="mb-4">
            These Terms of Service ("Terms") govern your access to and use of the Zahoot website, 
            services, and applications (the "Service"). Please read these Terms carefully, and contact us 
            if you have any questions. By accessing or using our Service, you agree to be bound by these Terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Using Our Services</h2>
          <p className="mb-4">
            You must follow any policies made available to you within the Services. You may use our Services 
            only as permitted by law. We may suspend or stop providing our Services to you if you do not 
            comply with our terms or policies or if we are investigating suspected misconduct.
          </p>
          <p className="mb-4">
            Using our Services does not give you ownership of any intellectual property rights in our 
            Services or the content you access. You may not use content from our Services unless you obtain 
            permission from its owner or are otherwise permitted by law.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Your Account</h2>
          <p className="mb-4">
            You may need an account in order to use some of our Services. You are responsible for safeguarding 
            your account, so use a strong password and limit its use to this account. We cannot and will not be 
            liable for any loss or damage arising from your failure to comply with the above.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Privacy and Copyright Protection</h2>
          <p className="mb-4">
            Our privacy policies explain how we treat your personal data and protect your privacy when you use 
            our Services. By using our Services, you agree that we can use such data in accordance with our 
            privacy policies.
          </p>
          <p className="mb-4">
            We respond to notices of alleged copyright infringement and terminate accounts of repeat infringers 
            according to the process set out in applicable law.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Modifying and Terminating our Services</h2>
          <p className="mb-4">
            We are constantly changing and improving our Services. We may add or remove functionalities or 
            features, and we may suspend or stop a Service altogether. You can stop using our Services at any 
            time, although we'll be sorry to see you go. We may also stop providing Services to you, or add or 
            create new limits to our Services at any time.
          </p>
          <p className="mb-4">
            We believe that you own your data and preserving your access to such data is important. If we 
            discontinue a Service, where reasonably possible, we will give you reasonable advance notice and a 
            chance to get information out of that Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Liabilities</h2>
          <p className="mb-4">
            When permitted by law, Zahoot, and its suppliers and distributors, will not be responsible for 
            lost profits, revenues, or data, financial losses or indirect, special, consequential, exemplary, 
            or punitive damages.
          </p>
          <p className="mb-4">
            To the extent permitted by law, the total liability of Zahoot, and its suppliers and distributors, 
            for any claims under these terms, including for any implied warranties, is limited to the amount 
            you paid us to use the Services (or, if we choose, to supplying you the Services again).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Changes to These Terms</h2>
          <p className="mb-4">
            We may revise these Terms from time to time to better reflect:
          </p>
          <ul className="list-disc pl-6 mt-2 mb-4 space-y-2">
            <li>Changes to the law</li>
            <li>New regulatory requirements</li>
            <li>Improvements or enhancements made to our Services</li>
          </ul>
          <p className="mt-3 mb-4">
            If we make a material change to these Terms, we will notify you via the Service or by email. 
            Changes will be effective no sooner than the day they are publicly posted. Your continued use of the Service after the changes become effective constitutes your acceptance of the changes.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="mb-4">
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="font-medium mt-2 mb-4">
            Email: support@zahoot.ai<br />
            Phone: +44 121 630 0000
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfServicePage; 